"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "treppo-grande": {
    "212e62bc": [{
      "hkey": "51f4149f",
      "slug": "vendoglio-carvacco",
      "name": "Vendoglio-Carvacco",
      "primary": true,
      "skipSearch": false
    }],
    "carvacco": [{
      "hkey": "51f4149f",
      "slug": "vendoglio-carvacco",
      "name": "Vendoglio-Carvacco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "treppo-grande"
    }],
    "cc93294b": [{
      "hkey": "51f4149f",
      "slug": "vendoglio-carvacco",
      "name": "Vendoglio-Carvacco",
      "primary": true,
      "skipSearch": false
    }],
    "vendoglio": [{
      "hkey": "51f4149f",
      "slug": "vendoglio-carvacco",
      "name": "Vendoglio-Carvacco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ad305a40": [{
      "hkey": "0d9e24d3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "zegliacco": [{
      "hkey": "0d9e24d3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "treppo-grande"
    }],
    "825a5eaf": [{
      "hkey": "0d9e24d3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "zeglianutto": [{
      "hkey": "0d9e24d3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "treppo-grande"
    }]
  }
};
exports["default"] = _default;